import { createContext, useState } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({
        isAuthenticated: false,
        user: null,
        user_id: null,
        group_id: null,
        group_name: null,
        //groups: null,
        permissions: []
        //accessToken: null // Make sure this is part of the state chatgpt
    });

    return (
        <AuthContext.Provider value={{ auth, setAuth }} >
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;
